import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    component: () => import("../views/Default.vue"),
    children: [
      {
        path: "",
        name: "main_non",
        component: () => import("../views/Main_non.vue"),
      },
      {
        path: "main",
        name: "main",
        component: () => import("../views/Main.vue"),
      },
    ],
  },
  {
    path: "/info",
    component: () => import("../views/Info/Info.vue"),
    children: [
      {
        path: "",
        name: "info",
        component: () => import("../views/Info/Springsoft.vue"),
      },
      // {
      //   path: "business",
      //   component: () => import("../views/Info/Business.vue"),
      // },
      {
        path: "partnership",
        name: "partnership",
        component: () => import("../views/Info/Partnership.vue"),
      },
      {
        path: "map",
        name: "map",
        component: () => import("../views/Info/Map.vue"),
      },
    ],
  },
  {
    path: "/happytable",
    component: () => import("../views/HappyTable/Happytable.vue"),
    children: [
      {
        path: "",
        name: "happytable",
        component: () => import("../views/HappyTable/BrandStory.vue"),
      },
      {
        path: "award",
        name: "award",
        component: () => import("../views/HappyTable/Award.vue"),
      },
      {
        path: "update",
        name: "update",
        component: () => import("../views/HappyTable/Update.vue"),
      },
    ],
  },
  // {
  //   path: "/product",
  //   name: "product",
  //   component: () => import("../views/Product.vue"),
  //   props: true,
  // },
  {
    path: "/productinfo",
    component: () => import("../views/HappyTable/Happytable.vue"),
    children: [
      {
        path: "",
        alias: "43inch",
        name: "productinfo",
        component: () => import("../views/ProductInfo/HappyTable43Inch.vue"),
      },
      {
        path: "32inch",
        name: "32inch",
        component: () => import("../views/ProductInfo/HappyTable32Inch.vue"),
      },
      {
        path: "happytablet",
        name: "happytablet",
        component: () => import("../views/ProductInfo/HappyTablet.vue"),
      },
    ],
  },
  // {
  //   path: "/game",
  //   name: "game",
  //   component: () => import("../views/Game/Game.vue"),
  // },
  {
    path: "/cognition",
    component: () => import("../views/Cognition/CognitionView.vue"),
    children: [
      {
        path: "",
        alias: "game",
        name: "cognition",
        component: () => import("../views/Game/Game.vue"),
      },
      {
        path: "multigame",
        alias: "",
        name: "multigame",
        component: () => import("../views/Game/MultiGame.vue"),
      },
      {
        path: "cognition",
        name: "cognitionDetail",
        component: () => import("../views/Cognition/Cognition.vue"),
      },
      {
        path: "story",
        name: "story",
        component: () => import("../views/Cognition/StoryWebtoon.vue"),
      },
    ],
  },
  {
    path: "/news",
    component: () => import("../views/News/NewsView.vue"),
    children: [
      {
        path: "",
        name: "news",
        component: () => import("../views/News/News.vue"),
      },
      {
        // 글 보는 페이지
        path: "detail",
        name: "newsDetail",
        component: () => import("../views/News/NewsDetail.vue"),
      },
      {
        path: "write",
        name: "newsWrite",
        component: () => import("../views/News/NewsWrite.vue"),
      },
      {
        path: "reference",
        name: "reference",
        component: () => import("../views/News/Reference.vue"),
      },
      {
        path: "faq",
        name: "faq",
        component: () => import("../views/News/NewsFAQ.vue"),
      },
      // {
      //   path: "more",
      //   component: () => import("../views/News/ReferenceMore.vue"),
      // },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/hyodol",
    name: "hyodol",
    component: () => import("../views/Hyodol.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      document.getElementById("app").scrollTo(0, 0);
      return {x: 0, y: 0};
    }
  },
});

export default router;
